import { executeActions, sampleAnalytics } from "@utils/index";
import { IconContainer, InfotextContainer, MmvInfoWrapper, OptionsContainer, StyledText } from "./styles";
import InfoIcon from "@public/images/icons/info-icon.svg";
import { FormatCTAtext } from "@components/mmvNotFoundModal";
import StyledSelect from "@widgets/selectButton/styles";
import { setPayload } from "@actions/setPayloadData";

interface IsCommercialCarProps {
    infoText: string;
    shouldShowOptions: boolean;
    is_visible: boolean;
    styles?: any;
    actions?: any;
}

export const IsCommercialCar = ({
    infoText,
    shouldShowOptions,
    styles,
    actions
  }: IsCommercialCarProps) => {

    const handleClick = (selectedValue: string) => {
      const isCommercial = selectedValue === "Yes"
      setPayload({
        payloadData: {
          is_commercial: isCommercial
        }
      });
      const additionalArgs =  {
        is_commercial: isCommercial
      }
      for(const action of actions["on_click"]) {
        if(action.args.edata) {
          action.args.edata = {
            ...action.args.edata,
            ...additionalArgs
          }
        }
      }
      executeActions(actions["on_click"], additionalArgs);
    };
    
    return (
      <MmvInfoWrapper styles={styles}>
        {infoText && <InfotextContainer>
          <IconContainer>
            <InfoIcon height="75%" width="75%" />
          </IconContainer>
          <StyledText>{infoText}</StyledText>
        </InfotextContainer>}
        {shouldShowOptions && (
          <OptionsContainer>
            <StyledSelect
              handleClick={() =>
                handleClick && handleClick("Yes")
              }
              styles={{ maxWidth: "107px", color: "#040222" }}
            >
              <FormatCTAtext>Yes</FormatCTAtext>
            </StyledSelect>
            <StyledSelect
              handleClick={() =>
                handleClick && handleClick("No")
              }
              styles={{ maxWidth: "107px", color: "#040222" }}
            >
              <FormatCTAtext>No</FormatCTAtext>
            </StyledSelect>
          </OptionsContainer>
        )}
      </MmvInfoWrapper>
    );
  };